import React, { useRef, useState } from "react";
import { IPermissionProps } from "../../../models/Login";
import { Toast } from "primereact/toast";
import { Form } from "./Form";
import RFPProposalTeamMemberForm from "./RFPProposalTeamMemberForm";
import MoveProposalTeamMembersForm from "./MoveProposalTeamMembersForm";
import { Table } from "./Table";
export interface IProposalTeamMast {
  branch?: string;
  company?: string;
  team_ID?: number;
  team_Manager?: string;
  team_Name?: string;
  category?: string;
}
export interface IProposalTeamData {
  branch?: string;
  branch_ID?: number;
  company?: string;
  company_ID?: number;
  team_ID?: number;
  team_Manager?: string;
  team_Manager_ID?: number;
  team_Name?: string;
  tender_Client_Category?: number;
}

export interface IRFProposalTeamManagement {
  Team_ID?: number;
  Team_Name?: string;
  Tender_Client_Category?: number;
  Status?: boolean;
  User_Added_by?: number;
  CreatedOn?: Date;
  TeamManagerid?: number;
  Company_Name?: number;
  Branch_Name?: number;
}

export interface IModel {
  open: boolean;
  singleData: IRFProposalTeamManagement;
  teamNameList: IProposalTeamMast[];
}

export interface IModel2 {
  open: boolean;
  singleData: IProposalTeamData;
}

export interface IModel3 {
  open: boolean;
  singleData: IProposalTeamData[];
  inTeam: IProposalTeamData;
}

export const EmptyProposalTeam: IRFProposalTeamManagement = {
  Team_Name: "",
  Company_Name: 0,
  Branch_Name: 0,
  TeamManagerid: 0,
};

export const ProposalTeamData: IProposalTeamData = {
  branch: "",
  branch_ID: 0,
  company: "",
  company_ID: 0,
  team_ID: 0,
  team_Manager: "",
  team_Manager_ID: 0,
  team_Name: "",
  tender_Client_Category: 0,
};
const RFPProposalTeamManagement = (permissions: IPermissionProps) => {
  const [modal, setModal] = useState({ singleData: EmptyProposalTeam, open: false, teamNameList: [] } as IModel);
  const [modal2, setModal2] = useState({ singleData: ProposalTeamData, open: false } as IModel2);
  const [modal3, setModal3] = useState({ singleData: [], open: false, inTeam: ProposalTeamData } as IModel3);
  const [reload, setReload] = useState(false);
  const [reload2, setReload2] = useState(false);
  const [reload3, setReload3] = useState(false);
  const toast = useRef<any>(null);

  const hideDialog = () => {
    setModal({ singleData: EmptyProposalTeam, open: false, teamNameList: [] });
  };
  const hideDialog2 = () => {
    setModal2({ singleData: ProposalTeamData, open: false });
  };
  const hideDialog3 = () => {
    setModal3({ singleData: [], open: false, inTeam: ProposalTeamData });
  };

  return (
    <>
      <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} teamNameList={modal.teamNameList}></Form>
      <RFPProposalTeamMemberForm singleData={modal2.singleData} open={modal2.open} hideDialog={hideDialog2} toast={toast} reload={reload2} setReload={setReload2} setModal={setModal} setModal3={setModal3} />
      <MoveProposalTeamMembersForm singleData={modal3.singleData} open={modal3.open} hideDialog={hideDialog3} toast={toast} reload={reload3} setReload={setReload3} inTeam={modal3.inTeam} setModal={setModal2} />
      <Table permissions={permissions} setModal={setModal} setModal2={setModal2} toast={toast} reload={reload} setReload={setReload}></Table>
      <Toast ref={toast} />
    </>
  );
};

export default RFPProposalTeamManagement;
